import React, { useEffect, useRef } from "react";
import Lottie from "react-lottie";

import mouseDown from "lottie/mouse-down";

import "./hero.scss";

import { heroCarousel } from "site-structure";

const Hero = ({ video, overtitle, logo, cta }) => {
	const defaultLottieOptions = {
		loop: true,
		autoplay: true,
		animationData: mouseDown,
		rendererSettings: {
			preserveAspectRatio: "xMidYMid slice",
		},
	};
	return (
		<>
			<section className="home-section home-full-height" id="home">
				<div className="hero-slider">
					<div className="slides">
						<div className="item">
							<div
								className="bg-dark-30 restaurant-page-header bg-dark"
								style={{
									height: "100vh",
								}}>
								<video
									autoPlay
									loop
									muted
									playsInline
									height={"100vh"}
									width={"100%"}
									style={{
										position: "absolute",
										height: "100%",
										objectFit: "cover",
										zIndex: 0,
										left: 0,
										right: 0,
										top: 0,
										left: 0,
									}}>
									<source src={video} type="video/mp4" />
									Your browser does not support the video tag.
								</video>
								<div
									className="titan-caption"
									style={{
										zIndex: 1,
										backgroundColor: "rgba(0, 0, 0, .5)",
									}}>
									<div className="caption-content">
										<div className="font-alt mb-20 titan-title-size-1"> {overtitle}</div>
										<div className="font-alt mb-30 titan-title-size-4">
											<img src={logo} className="logo-hero" />
										</div>

										{cta && (
											<a
												className="section-scroll btn btn-big btn-theme btn-round"
												target="_blank"
												rel="noreferrer"
												href={heroCarousel[0].action}>
												{heroCarousel[0].callToAction}
											</a>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="mouse-down">
						<div>
							<Lottie options={defaultLottieOptions} height={60} width={60} />
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default Hero;
